import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { GS_FIELDS_SKELETON_LOADERS_COUNT } from '../constants'

const GSFieldsLoadingView = (): React.ReactElement => (
   <div className='flex h-full'>
      {Array.from(new Array(GS_FIELDS_SKELETON_LOADERS_COUNT)).map(
         (item, index) => {
            const isLastItem = index === GS_FIELDS_SKELETON_LOADERS_COUNT - 1

            return (
               <Skeleton
                  duration={1.5}
                  width={70}
                  height={'100%'}
                  style={{
                     color: `#F6F7F9`,
                     background: `#EAECF0`,
                     borderRadius: '6px',
                     marginLeft: '8px',
                     marginRight: isLastItem ? '8px' : '0px'
                  }}
               />
            )
         }
      )}
   </div>
)

export default GSFieldsLoadingView
